"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[5991],{

/***/ 65937:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   v: () => (/* binding */ InquireContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

const InquireContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const InquireProvider = InquireContext.Provider;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InquireProvider);


/***/ }),

/***/ 44649:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const InquireDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "Inquire"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "PurchaseInquiryInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "purchaseInquiry"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "items"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "subscription"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "CartSubscription"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "giftSubscription"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "CartGiftSubscription"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "giftCard"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "CartGiftCard"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "ecommercePromos"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "CartProducts"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "products"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "CartProducts"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "limitedDropItems"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "CartLimitedDropItems"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "queueItems"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "CartQueueItems"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "subscriptionCase"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "image"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "rebrandImage"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "subscriptionPromos"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "CartSubscriptionPromos"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "queuePromos"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "CartProducts"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "premiumProducts"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "price"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "product"
                                                                        },
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "FragmentSpread",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "CartProduct"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "discounts"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "CartDiscounts"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "shipping"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "CartShipping"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "credits"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "CartCredits"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "tax"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "label"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "amount"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subTotal"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "total"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "error"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "PurchaseError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "purchaseErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "CouponError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "couponErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ServerError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "serverErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "CartError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "cartErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "CartProduct"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Product"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "image"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rebrandImage"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fullName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "brandInfo"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "volume"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "unit"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "gender"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "theEdit"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "typeGroup"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "upchargePrice"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rebrandLabels"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "marketing"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "extra"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "characteristic"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "CartGiftRecipient"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "GiftCardRecipient"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "email"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "message"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "CartGiftSender"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "GiftCardSender"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "email"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "CartSubscription"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "SubscriptionLineItem"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "label"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "price"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plan"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "productsPerPeriod"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "coupon"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "code"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "origin"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "discountAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "discountPercentage"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "shouldCharge"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "freeProduct"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "CartProduct"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "CartGiftSubscription"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "GiftSubscriptionLineItem"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "label"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "offer"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "freeProductsAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "image"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "priceOfferText"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "whatYouAreGetting"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "price"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plan"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "billingPeriod"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "recipient"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "CartGiftRecipient"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "CartGiftCard"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "GiftCardLineItem"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "product"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "label"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "price"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "recipient"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "CartGiftRecipient"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "sender"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "CartGiftSender"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "CartProducts"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "ProductLineItem"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "quantity"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "offer"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "price"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "parentPurchaseTradingItemId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "product"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "CartProduct"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "drift"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "image"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "starterSet"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "price"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amountCents"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currencyCode"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "discountPrice"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amountCents"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currencyCode"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "variety"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "image"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "CartLimitedDropItems"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "LimitedDropLineItem"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "countdownState"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "expiredDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "image"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isPromo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "price"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "product"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "CartProduct"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "productState"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "quantity"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "giftProducts"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "title"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "CartQueueItems"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "QueueLineItem"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "price"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "product"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "CartProduct"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "CartSubscriptionPromos"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "SubscriptionPromo"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "title"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "promo"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "image"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "unit"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "volume"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rebrandImage"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "CartDiscounts"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "DiscountLineItem"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "label"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "unit"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "coupon"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "code"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "origin"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "CartShipping"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "ShippingLineItem"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "label"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "price"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "freeShippingRemain"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "freeShippingProgress"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "CartCredits"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CreditLineItem"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "label"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
InquireDocument["definitions"] = [
    ...new Set(InquireDocument.definitions)
];
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InquireDocument);


/***/ }),

/***/ 61766:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export getSubTotal */
const getRealPurchaseLevel = (items)=>{
    // TODO: check if new purchase level is needed for limited drops
    const hasEcommerce = Boolean(items.products || items.limitedDropItems);
    const hasSubscription = Boolean(items.subscription);
    const hasGiftSubscription = Boolean(items.giftSubscription);
    const hasGiftCard = Boolean(items.giftCard);
    if (hasGiftSubscription || hasGiftCard) {
        if (hasGiftSubscription && !hasGiftCard && !hasEcommerce && !hasSubscription) {
            return "GIFT_SUBSCRIPTION_ONLY";
        }
        if (hasGiftCard && !hasGiftSubscription && !hasEcommerce && !hasSubscription) {
            return "GIFT_CARD_ONLY";
        }
        // if we have overlapping items, use all
        return "ALL";
    }
    if (hasSubscription && hasEcommerce) {
        return "ECOMMERCE_AND_SUBSCRIPTION";
    }
    if (hasSubscription) {
        return "SUBSCRIPTION_ONLY";
    }
    if (hasEcommerce) {
        return "ECOMMERCE_ONLY";
    }
    return null;
};
// TODO to ask Backend change this logic and return subTotal price without shipping price and without discount (only product price) - added on 1/04/22 by vkudla
const getSubTotal = (items)=>{
    let subTotal = 0;
    const productTypes = [
        "subscription",
        "products",
        "giftSubscription",
        "giftCard",
        "queueItems",
        "limitedDropItems"
    ];
    productTypes.forEach((productType)=>{
        var _items_subscription_coupon, _items_subscription;
        if (!items[productType] || Array.isArray(items) && !items[productType].length) {
            return;
        }
        if (productType === "products" || productType === "queueItems") {
            subTotal += items[productType].reduce((result, item)=>result + item.price, 0);
            return;
        }
        if (productType === "limitedDropItems") {
            subTotal += items[productType].reduce((result, item)=>{
                const { isPromo, price, productState } = item;
                if (isPromo || productState !== "LIVE") {
                    return result;
                }
                return result + price;
            }, 0);
            return;
        }
        if (productType === "subscription" && ((_items_subscription = items.subscription) === null || _items_subscription === void 0 ? void 0 : (_items_subscription_coupon = _items_subscription.coupon) === null || _items_subscription_coupon === void 0 ? void 0 : _items_subscription_coupon.code) === "NO_CHARGE") {
            return;
        }
        subTotal += items[productType].price;
    });
    return subTotal;
};
const modifyInquire = (data, requestedPurchaseLevel, disabled)=>{
    var _items_giftSubscription_offer, _items_giftSubscription, _items_subscription;
    if (!data) {
        return {
            items: null,
            subTotal: 0,
            total: 0,
            hasEcommerce: false,
            hasLimitedDrops: false,
            hasSubscription: false,
            hasGiftCard: false,
            hasGiftSubscription: false,
            hasQueueItems: false,
            giftSubscriptionOfferCount: 0,
            isGiftsOnly: false,
            isChargeable: false,
            isEmpty: true,
            requestedPurchaseLevel,
            realPurchaseLevel: requestedPurchaseLevel,
            disabled: false
        };
    }
    // process orders data
    const { items, total } = data;
    // we need to calculate the real level only when the requested one is ALL
    const realPurchaseLevel = requestedPurchaseLevel === "ALL" ? getRealPurchaseLevel(items) : requestedPurchaseLevel;
    const hasEcommerce = Boolean(items.products);
    const hasLimitedDrops = Boolean(items.limitedDropItems);
    const hasSubscription = Boolean(items.subscription);
    const hasGiftSubscription = Boolean(items.giftSubscription);
    const hasGiftCard = Boolean(items.giftCard);
    const hasQueueItems = Boolean(items.queueItems);
    const giftSubscriptionOfferCount = (_items_giftSubscription = items.giftSubscription) === null || _items_giftSubscription === void 0 ? void 0 : (_items_giftSubscription_offer = _items_giftSubscription.offer) === null || _items_giftSubscription_offer === void 0 ? void 0 : _items_giftSubscription_offer.freeProductsAmount;
    const subTotal = getSubTotal(items);
    const isGiftsOnly = (hasGiftCard || hasGiftSubscription) && !hasEcommerce && !hasLimitedDrops && !hasSubscription;
    const isEmpty = !hasEcommerce && !hasLimitedDrops && !hasSubscription && !hasGiftCard && !hasGiftSubscription && !hasQueueItems;
    // check if it's chargeable or free
    let isChargeable;
    const coupon = items === null || items === void 0 ? void 0 : (_items_subscription = items.subscription) === null || _items_subscription === void 0 ? void 0 : _items_subscription.coupon;
    // credit card and express checkout buttons should be visible to get payment info from user for recurrent
    // payments in future. Exception: user has "coupon.shouldCharge: false"
    if (realPurchaseLevel === "SUBSCRIPTION_ONLY") {
        isChargeable = (coupon === null || coupon === void 0 ? void 0 : coupon.shouldCharge) !== false;
    } else if (realPurchaseLevel === "ECOMMERCE_AND_SUBSCRIPTION") {
        // Exception: if "coupon.shouldCharge: false" which means that subscription is free; and total is 0
        isChargeable = !((coupon === null || coupon === void 0 ? void 0 : coupon.shouldCharge) === false && total === 0);
    } else {
        isChargeable = total > 0;
    }
    return {
        items,
        subTotal,
        total,
        hasEcommerce,
        hasLimitedDrops,
        hasSubscription,
        hasGiftCard,
        hasGiftSubscription,
        hasQueueItems,
        giftSubscriptionOfferCount,
        isGiftsOnly,
        isChargeable,
        isEmpty,
        requestedPurchaseLevel,
        realPurchaseLevel,
        disabled
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (modifyInquire);


/***/ }),

/***/ 39779:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _InquireProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65937);


const useInquire = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_InquireProvider__WEBPACK_IMPORTED_MODULE_1__/* .InquireContext */ .v);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useInquire);


/***/ }),

/***/ 89127:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60440);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83305);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53297);
/* harmony import */ var _modifyInquire__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61766);
/* harmony import */ var _graph_inquire_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44649);






const getAddress = (values)=>{
    const { country, postalCode, region, city, street1, street2 } = values;
    const isRequiredFieldsFilled = Boolean(country && postalCode && region && city && street1);
    if (!isRequiredFieldsFilled) {
        if (!country) {
            return null;
        }
        return {
            country
        };
    }
    // TODO validate postal code if needed - added on 2021-09-03 by maddoger
    return {
        country,
        postalCode,
        region,
        city,
        street1,
        street2
    };
};
const useInquireProvider = (props)=>{
    const { purchaseLevel, shippingForm, billingForm, initialSubscriptionPlan } = props;
    const apolloClient = (0,apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useApolloClient */ .x)();
    const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        orderData: null,
        isFetching: false
    });
    const queryPromiseRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const queryPromiseCounterRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    const isFirstQueryRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    const isGiftsOnlyRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const initialSubscriptionPlanRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(initialSubscriptionPlan);
    initialSubscriptionPlanRef.current = initialSubscriptionPlan;
    const submit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (options)=>{
        const currentCounter = ++queryPromiseCounterRef.current;
        try {
            setState((state)=>({
                    ...state,
                    isFetching: true
                }));
            let inquireInitialSubscriptionPlan;
            // TODO remove it when cart will be implemented - added on 2021-10-01 by maddoger
            // we should add subscription if user is on the subscribe page or if it's a first inquire for checkout page
            if (initialSubscriptionPlanRef.current && (purchaseLevel === "SUBSCRIPTION_ONLY" || purchaseLevel === "ALL" && isFirstQueryRef.current)) {
                inquireInitialSubscriptionPlan = initialSubscriptionPlanRef.current;
                isFirstQueryRef.current = false;
            }
            if (options === null || options === void 0 ? void 0 : options.initialSubscriptionPlan) {
                inquireInitialSubscriptionPlan = options === null || options === void 0 ? void 0 : options.initialSubscriptionPlan;
            }
            const createQueryPromise = async ()=>{
                // for digital products we use billing address instead of the shipping,
                // so we need to send billing to inquire too for tax calculation
                const address = getAddress(isGiftsOnlyRef.current ? billingForm.getValues() : shippingForm.getValues());
                logger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.info(`[Inquire] send inquire for ${purchaseLevel} ${address ? "with address" : ""}`);
                const result = await apolloClient.query({
                    fetchPolicy: "no-cache",
                    query: _graph_inquire_graphql__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                    variables: {
                        input: {
                            purchaseLevel,
                            address,
                            initialSubscriptionPlan: inquireInitialSubscriptionPlan
                        }
                    }
                });
                if (result.errors) {
                    throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .GraphQLError */ .__(result.errors);
                }
                if (!result.data.purchaseInquiry) {
                    throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .ServerError */ .nl(result.data, "purchaseInquiry is undefined");
                }
                const { data, error } = result.data.purchaseInquiry;
                // logic error
                if (error) {
                    if ("cartErrorCode" in error) {
                        // Do not throw error for empty cart, we will redirect user according to payment page logic
                        if (error.cartErrorCode === "CART_NOT_FOUND") {
                            return (0,_modifyInquire__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(null, purchaseLevel);
                        }
                        // Do not throw error for empty cart with limited drops,
                        // we will show payment page with disabled button and user can reactivate limited drop
                        if (error.cartErrorCode === "CART_IS_EMPTY") {
                            return (0,_modifyInquire__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(data, purchaseLevel, true);
                        }
                    }
                    throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .UserError */ .gK(error);
                }
                const orderData = (0,_modifyInquire__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(data, purchaseLevel);
                logger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.info({
                    orderData
                }, "[Inquire] result");
                // we should re-fetch the cart if user added subscription by inquire
                if (inquireInitialSubscriptionPlan) {
                    apolloClient.cache.evict({
                        id: "UserData:{}",
                        fieldName: "cart"
                    });
                }
                if (orderData.isGiftsOnly !== isGiftsOnlyRef.current) {
                    isGiftsOnlyRef.current = orderData.isGiftsOnly;
                    // refetch with the new address
                    return createQueryPromise();
                }
                return orderData;
            };
            // wrap the function to keep
            const queryPromise = createQueryPromise();
            // if we have promise, we need to provide new data to it
            if (queryPromiseRef.current) {
                queryPromiseRef.current.then(()=>queryPromise);
            }
            // and override value for new waiters
            queryPromiseRef.current = queryPromise;
            const orderData = await queryPromise;
            // update state only if current query is current
            // otherwise do nothing
            if (currentCounter === queryPromiseCounterRef.current) {
                setState({
                    orderData,
                    isFetching: false
                });
            }
        } catch (error) {
            setState((state)=>({
                    ...state,
                    isFetching: false
                }));
            (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .processError */ .wY)(error, "[Inquire] error");
        }
    }, [
        apolloClient,
        shippingForm,
        billingForm,
        purchaseLevel
    ]);
    const waitForData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async ()=>{
        return await queryPromiseRef.current;
    }, []);
    const setFetching = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((isFetching)=>{
        setState((state)=>({
                ...state,
                isFetching
            }));
    }, []);
    const { orderData, isFetching } = state;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        return {
            orderData,
            submit,
            waitForData,
            isFetching,
            setFetching
        };
    }, [
        submit,
        setFetching,
        orderData,
        isFetching,
        waitForData
    ]);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useInquireProvider);


/***/ }),

/***/ 65902:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11396);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53297);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83305);
/* harmony import */ var _graph_inquire_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44649);
/* harmony import */ var _modifyInquire__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61766);






const useInquireQuery = (props)=>{
    var _variables_input;
    const { variables, skip } = props;
    const requestedPurchaseLevel = (variables === null || variables === void 0 ? void 0 : (_variables_input = variables.input) === null || _variables_input === void 0 ? void 0 : _variables_input.purchaseLevel) || "ALL";
    const { data, refetch, isFetching } = (0,apollo_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_graph_inquire_graphql__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        variables,
        skip,
        fetchPolicy: "no-cache",
        notifyOnNetworkStatusChange: true
    });
    const orderData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        if (!(data === null || data === void 0 ? void 0 : data.purchaseInquiry)) {
            return null;
        }
        const { data: inquireData, error } = data.purchaseInquiry;
        if (error) {
            logger__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.warn(new helpers__WEBPACK_IMPORTED_MODULE_4__/* .UserError */ .gK(error));
            return null;
        }
        return (0,_modifyInquire__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(inquireData, requestedPurchaseLevel);
    }, [
        data,
        requestedPurchaseLevel
    ]);
    return {
        orderData,
        refetch,
        isFetching
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useInquireQuery);


/***/ })

}]);